import memoryAxiosInstance from '../../../core/api/memoryAxios';

export const getUserByExternalId = async (externalId: string) => {
  try {
    const { data } = await memoryAxiosInstance.post('/api/v1/auth/morpheus', {
      externalId,
    })

    return data;
  } catch(err){
    throw new Error(err as string)
  }
}